let splideInstance = null;
let debounceTimeout = null;
let isTransitioning = true;

function initSplide() {
  const el = document.getElementById('cart-announcement-slider');
  if (!el || !window.Splide) return;

  let currentIndex = 0;

  if (splideInstance) {
    currentIndex = splideInstance.index;
    try { splideInstance.destroy(); } catch (e) {}
    splideInstance = null;
  }

  splideInstance = new Splide(el, {
    type: 'loop',
    perPage: 1,
    // rewind: true,
    // rewindSpeed: 500,
    autoplay: true,
    interval: 3000,
    arrows: true,
    pagination: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    start: currentIndex, // restore last slide index
    speed: 800, // milliseconds for smoother transition
    easing: 'ease-in-out', // smooth easing animation
  });

  splideInstance.mount();

  // Pause autoplay after user interaction, then restart after a delay
  const resetAutoplay = () => {
    if (splideInstance?.Components?.Autoplay) {
      splideInstance.Components.Autoplay.pause();
      setTimeout(() => {
        splideInstance.Components.Autoplay.play();
      }, 2000); // 2 seconds delay before autoplay resumes
    }
  };

  splideInstance.on('moved', resetAutoplay); // covers arrow clicks
  splideInstance.on('dragged', resetAutoplay); // covers touch drag/swipe

  console.log('Splide initialized at slide', currentIndex);
}

function isMeaningfulMutation(mutations) {
  for (const m of mutations) {
    for (const node of [...m.addedNodes, ...m.removedNodes]) {
      if (node.nodeType !== 1) continue;
      if (node.classList?.contains('ms-zero-overlay')) continue;
      if (node.classList?.contains('ms-gift-overlay')) continue;
      if (node.childElementCount === 0 &&
         (node.hasAttribute?.('data-ms-gift-line') ||
          node.hasAttribute?.('data-ms-zero-gift') ||
          node.hasAttribute?.('data-ms-gift-locked'))) continue;
      return true; // real cart change
    }
  }
  return false;
}

// ReinitSplide after cart update like product added, Quantity increase
document.addEventListener('DOMContentLoaded', () => {
  initSplide();

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const safeInitSplide = () => {
    const el = document.getElementById('cart-announcement-slider');

    // If element doesn't exist yet, wait
    if (!el) return;

    if (
      splideInstance &&
      splideInstance.root.isConnected &&
      splideInstance.root === el &&
      (isTransitioning || splideInstance.Components.Autoplay?.playing)
    ) {
      return;
    }

    initSplide();
  };

  const debounceInit = () => {
    if (debounceTimeout) clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      safeInitSplide();
    }, 300);
  };

  // Only reinit for real cart mutations — ignore engine overlay injections
  const observer = new MutationObserver((mutations) => {
    if (!isMeaningfulMutation(mutations)) return;
    debounceInit();
  });
  observer.observe(cartDrawer, { childList: true, subtree: true });

  // Don't re-init on arrow click (filter it out)
  cartDrawer.addEventListener('click', (e) => {
    const isArrow = e.target.closest('.splide__arrow');
    if (isArrow) return; // 👈 Exit early for slider arrows

    const isQtyBtn = e.target.closest('button.quantity__button[name="plus"]') ||
                     e.target.closest('button.quantity__button[name="minus"]');
    if (isQtyBtn) {
      debounceInit(); // Only if NOT arrow
    }
  });

  cartDrawer.addEventListener('change', (e) => {
    if (e.target.matches('input.quantity__input')) {
      debounceInit();
    }
  });
});